"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TextAlignment;
(function (TextAlignment) {
    TextAlignment["Left"] = "left";
    TextAlignment["Right"] = "right";
    TextAlignment["Center"] = "center";
    TextAlignment["Justify"] = "justify";
})(TextAlignment = exports.TextAlignment || (exports.TextAlignment = {}));
